/**
 * Minimal document.cookie access.
 *
 * The web-plugin pulled in react-cookie for this; here the only cookie that
 * matters is the session id, so a couple of functions replace the dependency
 * and keep the write options (SameSite/expiry) explicit at the call site.
 */

const DEFAULT_MAX_AGE_DAYS = 30;

export function readCookie(name) {
  try {
    const match = document.cookie
      .split('; ')
      .find(entry => entry.split('=')[0] === name);

    if (!match) {
      return null;
    }
    // Only the first '=' separates name from value; the value may contain more.
    const value = match.slice(match.indexOf('=') + 1);
    return decodeURIComponent(value);
  } catch (e) {
    return null;
  }
}

export function writeCookie(name, value, maxAgeDays = DEFAULT_MAX_AGE_DAYS) {
  try {
    const maxAge = Math.round(maxAgeDays * 24 * 60 * 60);
    // SameSite=Lax keeps the cookie on normal navigations. When the app is
    // embedded cross-site in an iframe the browser drops it - that is expected,
    // and the session then lives for the lifetime of the frame instead.
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  } catch (e) {
    // Cookies can be blocked entirely; callers keep working from state.
  }
}

export function deleteCookie(name) {
  try {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
  } catch (e) {
    /* ignore */
  }
}

export function readJsonCookie(name) {
  const raw = readCookie(name);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
